import { render, staticRenderFns } from "./PainelVotacoes.vue?vue&type=template&id=5d2fbfd3"
import script from "./PainelVotacoes.vue?vue&type=script&lang=js"
export * from "./PainelVotacoes.vue?vue&type=script&lang=js"
import style0 from "./PainelVotacoes.vue?vue&type=style&index=0&id=5d2fbfd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports